import {
  loadMoreSubs,
  refreshSubs,
  setSubsPage,
  toggleMenuModeSection,
} from './legacyBridge/legacyActions'
import {
  normalizeSubsSection,
  type SubsNavigationAction,
  type SubsNavigationSection,
} from './contracts/subsNavigation'
import { treeStore } from './state'

export * from './contracts/subsNavigation'

export type SubsNavigationRequest = SubsNavigationAction & {
  section: SubsNavigationSection | 0 | 1
  target: unknown
}

export function dispatchSubsNavigation(request: SubsNavigationRequest): unknown {
  const section = normalizeSubsSection(request.section)

  if (request.action === 'load-more') {
    return loadMoreSubs(request.target, request.parentElId, section)
  }
  if (request.action === 'refresh') {
    return refreshSubs(request.target, section)
  }
  if (request.action === 'switch-section') {
    treeStore.mutate.setActiveSection(section === 1 ? 'submsges' : 'answers')
    return toggleMenuModeSection(request.target, request.mode, section)
  }

  const page = request.page === 'previous' ? 'prev' : request.page
  return setSubsPage(request.target, section, page)
}
